import {WirelessConfigDepo} from "./wireless_config"

export class MapDepo extends WirelessConfigDepo {
}
